<div class="tag-container" matTooltip="{{ tag }} tag">
  <span>{{ tag }}</span>
</div>
